const FREE_SHIPPMENT_OVER_PRICE = 400

export const countHowMuchLeftToFreeShipping = price =>
  (price && FREE_SHIPPMENT_OVER_PRICE - price) || FREE_SHIPPMENT_OVER_PRICE
